"use client"

import { useMounted } from "@/hooks/use-mounted"
import { useIpQuery } from "@/services"
import useGlobalParamsStore from "@/store/global-params-store"
import * as React from "react"
import { useEffect } from "react"
import { Loader } from "./ui/loader"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type RegisterParamsComponentProps = {
  children: React.ReactNode
}

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

function RegisterParams({ children }: RegisterParamsComponentProps) {
  const mounted = useMounted()
  const { setIpAddress, setQueryString } = useGlobalParamsStore()
  const { data, isLoading } = useIpQuery()

  useEffect(() => {
    if (data?.ip) setIpAddress(data.ip)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    setQueryString(encodeURIComponent(window.location.href))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!mounted || isLoading) return <Loader />

  return children
}

export { RegisterParams }
export type { RegisterParamsComponentProps }
